import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate, useOutlet, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../navigation/AuthProvider';

export const LoginLayout = () => {
  const { userInfo } = useContext(AuthContext);
  const outlet = useOutlet();

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('redirect') || '/';

  console.log('LoginLayout userInfo', userInfo);

  const userAgent = navigator.userAgent.toLowerCase();

  if (
    userInfo &&
    location.pathname.indexOf('/sales/monthly') === -1 &&
    !/kakaotalk/i.test(userAgent)
  ) {
    navigate(redirectUrl === '/' ? '/sales/monthly' : redirectUrl, { replace: true });
  }

  return <div>{outlet}</div>;
};
